module.exports = __webpack_public_path__ + "img/telegram.7957e04f.png";